/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import { Button, Modal } from "antd";
import { Component, ErrorInfo } from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
};

type State = {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
  callStackVisible: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: undefined,
    errorInfo: undefined,
    callStackVisible: false,
  };

  public static getDerivedStateFromError(
    error: Error,
    errorInfo: ErrorInfo,
  ): State {
    return { hasError: true, error, errorInfo, callStackVisible: false };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.props.onError?.(error, errorInfo);
  }

  public render() {
    return (
      <>
        {this.state.hasError ? (
          this.props.fallback !== undefined ? (
            this.props.fallback
          ) : (
            <div>Something went wrong</div>
          )
        ) : (
          this.props.children
        )}
        {this.state.callStackVisible && (
          <Modal
            open
            onCancel={() =>
              this.setState({ ...this.state, callStackVisible: false })
            }
            width={1000}
            title={this.state.error?.toString()}
            footer={null}
          >
            <pre>{this.state.error?.stack?.toString()}</pre>
            <footer>
              <Button
                onClick={() =>
                  this.setState({ ...this.state, callStackVisible: false })
                }
              >
                Close
              </Button>
            </footer>
          </Modal>
        )}
      </>
    );
  }
}
